import { Enviroment } from '../../../../_config/constants/enviroment-v2.constant';
import { Dictionary } from '../constants/dictionary.constant';

export const tabOptions = (data) => {
	return [
		{
			key: 'pending',
			tab: Dictionary[Enviroment.LANGUAGE].pending,
			data: data,
			status: 'all',
		},
		{
			key: 'to_deliver',
			tab: Dictionary[Enviroment.LANGUAGE].to_deliver,
			data: data,
			status: '004',
		},
		{
			key: 'delivered',
			tab: Dictionary[Enviroment.LANGUAGE].delivered,
			data: data,
			status: '006',
		},
		{
			key: 'rejected',
			tab: Dictionary[Enviroment.LANGUAGE].rejected,
			data: data,
			status: '008',
		},
	];
};
